import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import AddButton from "../../../components/AddButton";
import ModalDetail from "../../../components/DetailModal";
import SearchAdvance from "../../../components/SearchAdvance";
import SearchAdvanceForm from "../../../components/SearchAdvanceForm";
import SearchBar from "../../../components/SearchBar";
import PaginatedTable from "../../../components/PaginatedTable";

// perubahan di atas tidak perlu

const DataAdmin = () => {
  const [admins, setAdmins] = useState([]);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [jabatan, setJabatan] = useState("");
  const [email, setEmail] = useState("");
  const [showFields, setShowFields] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [nama, setNama] = useState("");
  const [kode, setKode] = useState("");
  const [telp, setTelp] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const columns = [
    { key: "nama", label: "Nama" },
    { key: "jabatan", label: "Jabatan" },
    { key: "kode", label: "Kode Karyawan" },
    { key: "telp", label: "No. Telp" },
    { key: "tanggalMasuk", label: "Tanggal Masuk" },
    { key: "email", label: "Email" }, // diganti dari username
  ];

  useEffect(() => {
    const storedAdmins = JSON.parse(localStorage.getItem("admins")) || [];
    setAdmins(storedAdmins);
  }, [location]);

  const filteredAdmins = admins.filter((admin) => {
    const masuk = admin.tanggalMasuk;

    if (fromDate && masuk < fromDate) return false;
    if (toDate && masuk > toDate) return false;

    if (nama && !admin.nama?.toLowerCase().includes(nama.toLowerCase()))
      return false;
    if (
      jabatan &&
      !admin.jabatan?.toLowerCase().includes(jabatan.toLowerCase())
    )
      return false;
    if (kode && !admin.kode?.toLowerCase().includes(kode.toLowerCase()))
      return false;
    if (email && !admin.email?.toLowerCase().includes(email.toLowerCase()))
      return false;
    if (telp && !admin.telp?.toLowerCase().includes(telp.toLowerCase()))
      return false;

    if (
      search &&
      ![
        admin.nama,
        admin.jabatan,
        admin.kode,
        admin.telp,
        admin.email,
        admin.tanggalMasuk,
      ].some((field) =>
        field?.toString().toLowerCase().includes(search.toLowerCase())
      )
    ) {
      return false;
    }

    return true;
  });

  const handleEdit = (index) => {
    localStorage.setItem("editAdmin", JSON.stringify(filteredAdmins[index]));
    navigate("/edit-admin");
  };

  const handleDelete = (index) => {
    if (window.confirm("Yakin ingin menghapus data ini?")) {
      const updated = [...admins];
      const realIndex = admins.findIndex((a) => a === filteredAdmins[index]);
      updated.splice(realIndex, 1);
      setAdmins(updated);
      localStorage.setItem("admins", JSON.stringify(updated));
    }
  };

  const handleView = (index) => {
    const selected = filteredAdmins[index];
    if (selected) {
      setSelectedAdmin(selected);
      setShowDetailModal(true);
    }
  };

  const handleClearFilters = () => {
    setFromDate("");
    setToDate("");
    setNama("");
    setJabatan("");
    setKode("");
    setEmail("");
    setTelp("");
  };

  return (
    <div className="pt-10 pl-64">
      <h2 className="pl-6 mb-6 text-2xl font-semibold text-green-700">
        Data Admin
      </h2>
      <div className="p-6 mx-4 bg-white shadow rounded-xl">
        <div className="flex items-center justify-between mb-4">
          <AddButton
            onClick={() => navigate("/add-admin")}
            moduleName="Data Admin"
          />
          <div className="flex items-center gap-2">
            <SearchBar value={search} onChange={setSearch} />
            <SearchAdvance
              showFields={showFields}
              toggleShowFields={() => setShowFields(!showFields)}
            />
          </div>
        </div>

        {showFields && (
          <SearchAdvanceForm
            dateFields={[
              {
                label: "Tanggal Masuk",
                fromValue: fromDate,
                toValue: toDate,
                onFromChange: setFromDate,
                onToChange: setToDate,
              },
            ]}
            additionalFields={[
              {
                label: "Nama",
                value: nama,
                onChange: setNama,
              },
              {
                label: "Jabatan",
                value: jabatan,
                onChange: setJabatan,
              },
              {
                label: "Kode Karyawan",
                value: kode,
                onChange: setKode,
              },
              {
                label: "No. Telp",
                value: telp,
                onChange: setTelp,
              },
              {
                label: "Email",
                value: email,
                onChange: setEmail,
              },
            ]}
            onClear={handleClearFilters}
          />
        )}

        <PaginatedTable
          data={filteredAdmins}
          columns={columns}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onView={handleView}
          moduleName="Data Admin"
        />

        {showDetailModal && (
          <ModalDetail
            data={selectedAdmin}
            onClose={() => setShowDetailModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default DataAdmin;
